var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M7.01 1C8.154 1 9 1.847 9 3.003V6.25l.018-.01c.246-.13.526-.21.829-.23L10 6.005c.722 0 1.335.34 1.685.885l.032.054.078-.06c.244-.18.534-.303.859-.357l.165-.021.176-.008c.902 0 1.607.5 1.881 1.264l.017.054.085-.053c.252-.144.544-.234.861-.257L16 7.5c1.156 0 2 .889 2 2v5.098a4.374 4.374 0 0 1-1.33 3.116A4.532 4.532 0 0 1 13.5 19H8.923a5.207 5.207 0 0 1-4.32-2.294l-2.815-5.13a1.651 1.651 0 0 1 0-1.864 1.7 1.7 0 0 1 1.15-.72c.468-.072.945.052 1.353.375l.709.678V3.003c0-1.101.785-1.925 1.854-1.998ZM14 8.5c0-.612-.39-1.002-.982-1.002l-.132.005a.94.94 0 0 0-.88.874L12 8.484V9.5a.5.5 0 0 1-.992.09L11 9.5V8l-.006-.125c-.054-.526-.448-.87-.994-.87-.592 0-1 .391-1 .985V9a.5.5 0 0 1-.992.09L8 9V3.003C8 2.399 7.602 2 7.01 2 6.41 2 6 2.405 6 3.003v8.211a.5.5 0 0 1-.845.362l-1.518-1.454a.715.715 0 0 0-1.023.153c-.152.224-.152.514.026.779l2.814 5.13A4.194 4.194 0 0 0 8.924 18H13.5c.927 0 1.818-.36 2.47-1A3.375 3.375 0 0 0 17 14.598V9.5c0-.57-.408-1-1-1-.56 0-.95.372-.994.88L15 9.491V10a.5.5 0 0 1-.992.09L14 10Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHand);
export default ForwardRef;